import { createContext } from 'react';
import noop from 'lodash/noop';

import api from '../api';
import { PriceLevel } from '../types';
import { Context } from '../../../types';

const priceLevelContext = createContext<Context<PriceLevel>>({
    get: api.get,
    getById: api.getById,
    getSchema: api.getSchema,
    schema: {},
    post: api.post,
    put: api.put,
    data: { ids: [], byId: {} },
    setData: noop,
    selected: null,
    setSelected: noop,
    remove: api.remove,
    softDelete: api.softDelete,
    error: null
});
export default priceLevelContext;
